import { useWatch } from 'react-hook-form';
import { useGoalEditPermissions } from 'hooks/GoalsAndSubgoalsForm';
import {
  SCORECARD_COMMON_GOAL_TYPE_CUSAT,
  SCORECARD_GOAL_TYPE_CUSAT,
} from 'constants/scorecards';

export default function useCommonGoalEditGating(
  goalIndex: number,
  goalsCount: number,
) {
  const permissions = useGoalEditPermissions(goalIndex, false, false);

  const [goalType] = useWatch({ name: [`goals.${goalIndex}.type`] });
  const isCuSat =
    goalType === SCORECARD_GOAL_TYPE_CUSAT ||
    goalType === SCORECARD_COMMON_GOAL_TYPE_CUSAT;

  const isRemoveDisabled = goalsCount <= 1;
  const canDeleteGoal = !isCuSat || (!isRemoveDisabled && permissions.canEdit);

  return { ...permissions, isCuSat, canDeleteGoal };
}
